export default {
  en: {
    actions: {
      resend: 'Resend invitation',
      withdraw: 'Withdraw',
    },
    snack: {
      resend_success: 'Invitation sent to %{recipient}',
      withdraw_success: 'Invitation was successfully canceled',
    },
  },
};
